import { render, staticRenderFns } from "./campSummaryTable.vue?vue&type=template&id=90a844c8&scoped=true&"
import script from "./campSummaryTable.vue?vue&type=script&lang=js&"
export * from "./campSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./campSummaryTable.vue?vue&type=style&index=0&id=90a844c8&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a844c8",
  null
  
)

export default component.exports